import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class Pagination extends React.Component {
    constructor(props) {
        super(props);
        this.handleSearchByPage = this.handleSearchByPage.bind(this);
    }

    handleSearchByPage(e) {
        e.preventDefault();
        const searchConditions = this.props.searchConditions;
        searchConditions.page = e.currentTarget.getAttribute('data-page');
        if (typeof this.props.onSearch === 'function') {
            this.props.onSearch(searchConditions);
        }
    }
    
    render() {
        return (
                <nav aria-label="navigation">
                    <ul className="pagination justify-content-center mb-0">
                        <li className="page-item">
                            <a className="page-link" data-page={this.props.currentPage - 1 > 0 ? this.props.currentPage - 1 : 1} onClick={this.handleSearchByPage} href="#" aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                                <span className="sr-only">Previous</span>
                            </a>
                        </li>
                        
                        {(() => {
                            const items = [];
                            if (this.props.lastPage < 11){
                                for (let i = 1; i <= this.props.lastPage; i++) {
                                    items.push(<li key={i} style={{ zIndex: 0 }} className={this.props.currentPage == i ? 'page-item active' : 'page-item'}><a data-page={i} onClick={this.handleSearchByPage} className="page-link" href="#">{i}</a></li>)
                                }
                            } else {
                                items.push(<li key="1" className={this.props.currentPage == 1 ? 'page-item active' : 'page-item'}><a data-page="1" onClick={this.handleSearchByPage} className="page-link" href="#">1</a></li>)
                                
                                if (this.props.currentPage > 4){
                                    items.push(<li key="first-dot" className={'page-item'}><a data-page={this.props.currentPage} onClick={this.handleSearchByPage} className="page-link" href="#">...</a></li>)
                                }
                                
                                if (![1, 2].includes(this.props.currentPage)){
                                    if (this.props.currentPage != 3){
                                        items.push(<li key={this.props.currentPage-2} className={'page-item'}><a data-page={this.props.currentPage-2} onClick={this.handleSearchByPage} className="page-link" href="#">{this.props.currentPage-2}</a></li>)
                                    }
                                    items.push(<li key={this.props.currentPage-1} className={'page-item'}><a data-page={this.props.currentPage-1} onClick={this.handleSearchByPage} className="page-link" href="#">{this.props.currentPage-1}</a></li>)
                                }
                                
                                if (![1, this.props.lastPage].includes(this.props.currentPage)){
                                    items.push(<li key={this.props.currentPage} className={'page-item active'}><a data-page={this.props.currentPage} onClick={this.handleSearchByPage} className="page-link" href="#">{this.props.currentPage}</a></li>)
                                }
                                
                                if (![this.props.lastPage, this.props.lastPage-1].includes(this.props.currentPage)){
                                    items.push(<li key={this.props.currentPage+1} className={'page-item'}><a data-page={this.props.currentPage+1} onClick={this.handleSearchByPage} className="page-link" href="#">{this.props.currentPage+1}</a></li>)
                                    if(this.props.currentPage != this.props.lastPage-2){
                                        items.push(<li key={this.props.currentPage+2} className={'page-item'}><a data-page={this.props.currentPage+2} onClick={this.handleSearchByPage} className="page-link" href="#">{this.props.currentPage+2}</a></li>)
                                    }
                                }
                                
                                if (this.props.currentPage < (this.props.lastPage - 3)){
                                    items.push(<li key="last-dot" className={'page-item'}><a data-page={this.props.currentPage} onClick={this.handleSearchByPage} className="page-link" href="#">...</a></li>)
                                }
                                
                                items.push(<li key={this.props.lastPage} className={this.props.currentPage == this.props.lastPage ? 'page-item active' : 'page-item'}><a data-page={this.props.lastPage} onClick={this.handleSearchByPage} className="page-link" href="#">{this.props.lastPage}</a></li>)
                            }
                            return items;
                        })()}
                        
                        <li className="page-item">
                            <a className="page-link" data-page={this.props.currentPage + 1 < this.props.lastPage ? this.props.currentPage + 1 : this.props.lastPage} onClick={this.handleSearchByPage} href="#" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                                <span className="sr-only">Next</span>
                            </a>
                        </li>
                    </ul>
                </nav>
                );
    }
}
